import * as React from 'react';
import EDHighchartsWrapper, { IOptions } from '../EDHighcharts';
import {
  SeriesBubbleOptions,
  DrilldownEventObject,
  FormatterCallbackFunction,
  AxisLabelsFormatterContextObject,
  Chart,
} from 'highcharts';

interface IProps {
  title?: string;
  yAxisLabel: string;
  formater?: FormatterCallbackFunction<AxisLabelsFormatterContextObject>;
  categories: string[];
  series: SeriesBubbleOptions[];
  drilldownEvent?: (event: DrilldownEventObject) => void;
  afterChartCreated?: (chart: Chart) => void;
}

const data: IOptions = {
  title: {
    text: undefined,
  },
  tooltip: {
    useHTML: true,
    headerFormat: '<table>',
    pointFormat:
      '<tr><th colspan="2"><h3>{series.name}</h3></th></tr>' +
      '<tr><th>Verksamhet:</th><td>{point.x}</td></tr>' +
      '<tr><th>Kostnad:</th><td>{point.y}</td></tr>' +
      '<tr><td>{point.z}%</td></tr>',
    footerFormat: '</table>',
    followPointer: true,
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
        format: '{point.name}',
      },
    },
  },
  yAxis: {
    reversed: true,
  },
  series: [
    {
      name: 'Bokfört tom/Dec -17',
      data: [
        { x: 110, y: -8031317.9, z: 38.3 },
        { x: 150, y: -1232424.76, z: 5.9 },
        { x: 160, y: -848916.98, z: 4.0 },
        { x: 170, y: -3059781.94, z: 14.6 },
        { x: 180, y: -754748.68, z: 3.6 },
        { x: 210, y: -5117623.03, z: 24.4 },
        { x: 260, y: -1919324.69, z: 9.2 },
      ],
    } as SeriesBubbleOptions,
    {
      name: 'Bokfört tom/Dec -18',
      data: [
        { x: 110, y: -9137782.77, z: 38.4 },
        { x: 150, y: -1346621.65, z: 5.7 },
        { x: 160, y: -1204948.45, z: 5.1 },
        { x: 170, y: -3788930.24, z: 15.9 },
        { x: 180, y: -814075.79, z: 3.4 },
        { x: 210, y: -5911176.57, z: 24.8 },
        { x: 260, y: -1597547.12, z: 6.7 },
      ],
    } as SeriesBubbleOptions,
  ],
};
/**
 * Bubbeldiagram där olika kategorier av värden kan jämföras över två axlar. 

Storleken på bubblan proportionell mot ytterligare värde. 
 */
class EDBubbleChart extends React.Component<IProps> {
  // getData = (): IOptions => {
  //   return {
  //     title: {
  //       text: null,
  //     },
  //     tooltip: {
  //       useHTML: true,
  //       headerFormat: '<table>',
  //       pointFormat:
  //         '<tr><th colspan="2"><h3>{series.name}</h3></th></tr>' +
  //         '<tr><th>Verksamhet:</th><td>{point.x}</td></tr>' +
  //         '<tr><th>Kostnad:</th><td>{point.y}</td></tr>' +
  //         '<tr><td>{point.z}%</td></tr>',
  //       footerFormat: '</table>',
  //       followPointer: true,
  //     },
  //     plotOptions: {
  //       series: {
  //         dataLabels: {
  //           enabled: true,
  //           format: '{point.name}',
  //         },
  //       },
  //     },
  //     yAxis: {
  //       reversed: true,
  //     },
  //     series: this.props.series,
  //   };
  // };

  render() {
    return (
      <div>
        <EDHighchartsWrapper
          type="bubble"
          options={data}
          afterChartCreated={this.props.afterChartCreated}
        />
      </div>
    );
  }
}

export default EDBubbleChart;
